import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import { DetectResponse } from '../../types';

type UseDetectionsProps = {
  fileId?: string;
};

export function useInvalidateDetections() {
  const [searchParams] = useSearchParams();
  const { clientId } = useCurrentClient();
  const fileId = searchParams.get('fileId') ?? '';
  const queryClient = useQueryClient();

  const invalidateDetections = () =>
    queryClient.invalidateQueries({
      queryKey: ['clients', clientId, 'data-upload-files', fileId, 'detections'],
    });

  return {
    invalidateDetections,
  };
}

export function useDetections({ fileId }: UseDetectionsProps) {
  const { clientId } = useCurrentClient();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<DetectResponse>({
    queryKey: ['clients', clientId, 'data-upload-files', fileId, 'detections'],
    enabled: !!clientId && !!fileId,
    staleTime: Infinity,
  });

  return {
    detections: data?.detections || [],
    isLoading,
    isFetching,
    isError,
    error,
    refetchDetections: refetch,
  };
}
